<template>

  <modal-layout
    :bgShow="error.show"
    :modalShow="error.show"
    @close="close">

    <div
      style="width: 530px"
      class="warning-modal">
      <div
        class="warning-modal__head">
        <img
          src="@/../static/img/icons/warning.svg">
        Ошибка
      </div>
      <div
        class="warning-modal__body">
        <div>
          Устройство не было отключено от iCloud. Отключите устройство и отправьте новый запрос на проверку через 2 минуты.
        </div>
      </div>
      <div
        class="warning-modal__footer">
        <button
          class="btn cancel"
          @click.prevent="send()">
          Отправить новый запрос
        </button>
      </div>
    </div>

  </modal-layout>

</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

import ModalLayout from './ModalLayout';

export default {
  components: {
    ModalLayout,
  },
  computed: {
    ...mapState('buyphones', ['model', 'questions', 'answers', 'error']),
  },
  methods: {
    ...mapActions('buyphones', ['getCalc']),
    ...mapMutations('buyphones', ['SET_ERROR']),

    close() {
      this.SET_ERROR({ show: false, type: '' });
    },

    send() {
      this.getCalc({
        btag: this.model.btag,
        questions: this.answers,
      })
      this.SET_ERROR({ show: false, type: '' });
    },
  },
}
</script>

<style lang="sass">
  @import '@/styles/components/modals/warning-modal.sass'
</style>
